import _ from "lodash";
import { useMutation } from "@tanstack/react-query";
import { FC } from "react";
import { Button } from "antd";
import { useNavigate, useParams } from "react-router-dom";
import { CheckOutlined } from "@ant-design/icons";
import PAGES from "routes/constants";
import Logo from "assets/images/logo.png";
import API from "services/api";
import { setLastAccessPage } from "services/storages/expiredStorage";
import usePackage from "stores/usePackage";

interface Props {
  dataHomeUploaded: any;
  isLogin: boolean;
  featureTwoffer?: boolean;
}

const Package: FC<Props> = ({ dataHomeUploaded, isLogin, featureTwoffer }) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { setRedirectUrlAfterAuth } = usePackage();

  const { mutateAsync: mutateACKOverlayPackage } = useMutation({
    mutationFn: (params: any) => API.mock.ackOverlayPackage(params),
  });

  const handleRapport = async () => {
    if (_.get(dataHomeUploaded, "quota_token", "")) {
      await mutateACKOverlayPackage({
        ref_ademe: id,
        quota_token: _.get(dataHomeUploaded, "quota_token", ""),
      });

      if (id) {
        const dashboardUrl = PAGES.dashboard.replace(":id", id || "");
        navigate(dashboardUrl, {
          state: { refresh: Date.now() },
          replace: true,
        });
      }
    }
  };

  const handlePaymentPackage = (offerId: string) => {
    setRedirectUrlAfterAuth(window.location.hash?.slice(1));
    navigate(PAGES.stripe, {
      state: {
        offerId: offerId,
        refAdeme: dataHomeUploaded.ademe,
        address: dataHomeUploaded.project_details.address,
      },
    });
  };

  if (_.get(dataHomeUploaded, "payment_required") === true) {
    if (featureTwoffer) {
      return (
      <div className="overlay">
        <div className="flex flex-col gap-4 max-w-max mx-auto">
          <div className="overlay__content">
            <div className="overlay__header">
              <p className=" text-center text-[#1e6862] text-[50px]">
                  Choisissez votre analyse
                </p>
                <span className="text-[24px] font-bold">
                      Des résultats fiables, avec un expert à votre écoute. Sans engagement.
                    </span>
            </div>

            <div className="offre-item offre-item--dark">
              <div className="flex-grow">
                <p className="title text-center text-[#002060ff]">
                  Fiabilité
                </p>
                <p className="text-[18px] text-center mb-2">
                  <span className="text-[24px] font-semibold">29 €</span> /
                  analyse
                </p>

                <ul className="flex flex-col gap-3 my-4 lg:min-h-[237px]">
                  <li className="flex items-baseline gap-4">
                    <CheckOutlined className="text-[18px] relative top-[2px]" />
                    <span className="text-[18px] font-bold">
                      Score de fiabilité de mon DPE
                    </span>
                  </li>
                  <li className="flex items-baseline gap-4">
                    <CheckOutlined className="text-[18px] relative top-[2px]" />
                    <span className="text-[18px] font-bold">
                      Identification des anomalies éventuelles
                    </span>
                  </li>
                  <li className="flex items-baseline gap-4">
                    <CheckOutlined className="text-[18px] relative top-[2px]" />
                    <span className="text-[18px] font-bold">
                      Rapport fiabilité (format pdf)
                    </span>
                  </li>
                  <li className="flex items-baseline gap-4">
                    <CheckOutlined className="text-[18px] relative top-[2px]" />
                    <span className="text-[18px] font-bold">
                      Echange avec un expert
                    </span>
                  </li>
                </ul>

                <Button
                  type="primary"
                  className="btn-rapport btn-rapport--dark mt-2"
                  onClick={() => handlePaymentPackage("4")}
                  disabled={_.get(dataHomeUploaded, "payment_blocked") === true}
                >
                  Obtenir mon rapport
                </Button>

                <p className="font-semibold text-[16px] mt-7 text-justify">
                Cette offre vous permet mesurer le niveau de fiabilité de votre DPE et d'avoir l'opportunité d'échanger avec un expert DPE pour comprendre les éventuelles anomalies et votre DPE.
                </p>
              </div>

              <img src={Logo} alt="logo" className="mx-auto mt-0 w-[80px]" />
            </div>

            <div className="offre-item">
              <div className="flex-grow">
                <p className="title text-center text-[#1e6862]">
                  Fiabilité + Rénovation
                </p>
                <p className="text-[18px] text-center">
                  <span className="text-[24px] font-semibold">69 €</span> /
                  analyse
                </p>

                <ul className="flex flex-col gap-3 my-4 lg:min-h-[237px]">
                  <li className="flex items-baseline gap-4">
                    <CheckOutlined className="text-[18px] relative top-[2px]" />
                    <span className="text-[18px] font-bold">
                      Toute l'offre Fiabilité
                    </span>
                  </li>
                  <li className="flex justify-center">
                    <span className="text-[28px] font-bold text-[#1e6862]">+</span>
                  </li>
                  <li className="flex items-baseline gap-4">
                    <CheckOutlined className="text-[18px] relative top-[2px]" />
                    <span className="text-[18px] font-bold">
                      Proposition de travaux adaptée à votre projet
                    </span>
                  </li>
                  <li className="flex items-baseline gap-4">
                    <CheckOutlined className="text-[18px] relative top-[2px]" />
                    <span className="text-[18px] font-bold">
                      DPE projeté selon les travaux proposés
                    </span>
                  </li>
                </ul>
                <Button
                  type="primary"
                  className="btn-rapport  mt-2"
                  onClick={() => handlePaymentPackage("2")}
                  disabled={_.get(dataHomeUploaded, "payment_blocked") === true}
                >
                  Obtenir mon rapport
                </Button>

                <p className="font-semibold text-[16px] mt-7 text-justify">
                  Cette offre vous permet de mesurer le niveau de fiabilité de 
                  votre DPE et de vous projeter dans des travaux permettant 
                  l'amélioration de votre logement selon votre projet (gain 
                  de lettre, budget, …).
                </p>
              </div>
              <img src={Logo} alt="logo" className="mx-auto mt-0 w-[80px]" />
            </div>
          </div>

        </div>
      </div>
    );
    }

    return (
      <div className="overlay">
        <div className="flex flex-col gap-4 max-w-max mx-auto">
          <div className="overlay__content !gap-x-6">
            <div className="overlay__header">
              <p className=" text-center text-[#1e6862] text-[50px]">
                  Choisissez votre analyse
                </p>
                <span className="text-[24px] font-bold">
                      Des résultats fiables, avec un expert à votre écoute. Sans engagement.
                    </span>
            </div>

            <div className="offre-item offre-item--dark">
              <div className="flex-grow">
                <p className="title text-center text-[#002060ff]">Fiabilité</p>
                <p className="text-[18px] text-center mb-2">
                  <span className="text-[24px] font-semibold">15 €</span> /
                  analyse
                </p>
                {/* <p className="text-[18px] text-center mb-1">
                  <strong>Offre lancement : 15 €</strong>
                </p> */}
                {/* <p className="text-[16px] text-center">jusqu’au 30/09/2025 </p> */}

                <ul className="flex flex-col gap-3 my-4 lg:min-h-[237px]">
                  <li className="flex items-baseline gap-4">
                    <CheckOutlined className="text-[18px] relative top-[2px]" />
                    <span className="text-[18px] font-bold">
                      Score de fiabilité de mon DPE
                    </span>
                  </li>
                  <li className="flex items-baseline gap-4">
                    <CheckOutlined className="text-[18px] relative top-[2px]" />
                    <span className="text-[18px] font-bold">
                      Identification des anomalies éventuelles
                    </span>
                  </li>
                  <li className="flex items-baseline gap-4">
                    <CheckOutlined className="text-[18px] relative top-[2px]" />
                    <span className="text-[18px] font-bold">
                      Rapport fiabilité (format pdf)
                    </span>
                  </li>
                </ul>

                <Button
                  type="primary"
                  className="btn-rapport btn-rapport--dark mt-2"
                  onClick={() => handlePaymentPackage("1")}
                  disabled={_.get(dataHomeUploaded, "payment_blocked") === true}
                >
                  Obtenir mon rapport
                </Button>

                <p className="text-[16px] mt-7 text-justify">
                  Cette offre vous permet de mesurer le niveau de fiabilité de
                  votre DPE et de comprendre les éventuels problèmes de saisies
                  ou de cohérence.
                </p>
              </div>

              <img src={Logo} alt="logo" className="mx-auto mt-0 w-[80px]" />
            </div>

            <div className="offre-item">
              <div className="py-1 px-4 bg-[#FFE082] rounded-full text-[#5D4037] font-bold absolute -top-3.5 -right-3 shadow-md">
                <span>Recommandée</span>
              </div>
              <div className="flex-grow">
                <p className="title text-center text-[#1e6862]">
                  Fiabilité + Expert
                </p>
                <p className="text-[18px] text-center mb-2">
                  <span className="text-[24px] font-semibold">29 €</span> /
                  analyse
                </p>

                <ul className="flex flex-col gap-3 my-4 lg:min-h-[237px]">
                  <li className="flex items-baseline gap-4">
                    <CheckOutlined className="text-[18px] relative top-[2px]" />
                    <span className="text-[18px]">
                      Score de fiabilité de mon DPE
                    </span>
                  </li>
                  <li className="flex items-baseline gap-4">
                    <CheckOutlined className="text-[18px] relative top-[2px]" />
                    <span className="text-[18px]">
                      Identification des anomalies éventuelles
                    </span>
                  </li>
                  <li className="flex items-baseline gap-4">
                    <CheckOutlined className="text-[18px] relative top-[2px]" />
                    <span className="text-[18px]">
                      Rapport fiabilité (format pdf)
                    </span>
                  </li>
                  <li className="flex items-baseline gap-4">
                    <CheckOutlined className="text-[18px] relative top-[2px]" />
                    <span className="text-[18px] font-bold">
                      Echange avec un expert
                    </span>
                  </li>
                </ul>

                <Button
                  type="primary"
                  className="btn-rapport  mt-2"
                  onClick={() => handlePaymentPackage("4")}
                  disabled={_.get(dataHomeUploaded, "payment_blocked") === true}
                >
                  Obtenir mon rapport
                </Button>

                <p className="font-semibold text-[16px] mt-7 text-justify">
                Cette offre vous permet mesurer le niveau de fiabilité de votre DPE et d'avoir l'opportunité d'échanger avec un expert DPE pour comprendre les éventuelles anomalies et votre DPE.
                </p>
              </div>

              <img src={Logo} alt="logo" className="mx-auto mt-0 w-[80px]" />
            </div>

            <div className="offre-item">
              <div className="flex-grow">
                <p className="title text-center text-[#1e6862]">
                  Fiabilité + Rénovation
                </p>
                <p className="text-[18px] text-center">
                  <span className="text-[24px] font-semibold">69 €</span> /
                  analyse
                </p>

                <ul className="flex flex-col gap-3 my-4">
                  <li className="flex items-baseline gap-4">
                    <CheckOutlined className="text-[18px] relative top-[2px]" />
                    <span className="text-[18px]">
                      Score de fiabilité de mon DPE
                    </span>
                  </li>
                  <li className="flex items-baseline gap-4">
                    <CheckOutlined className="text-[18px] relative top-[2px]" />
                    <span className="text-[18px]">
                      Identification des anomalies éventuelles
                    </span>
                  </li>
                  <li className="flex items-baseline gap-4">
                    <CheckOutlined className="text-[18px] relative top-[2px]" />
                    <span className="text-[18px]">
                      Rapport fiabilité (format pdf)
                    </span>
                  </li>
                  <li className="flex items-baseline gap-4">
                    <CheckOutlined className="text-[18px] relative top-[2px]" />
                    <span className="text-[18px]">
                      Echange avec un expert
                    </span>
                  </li>
                  <li className="flex items-baseline gap-4">
                    <CheckOutlined className="text-[18px] relative top-[2px]" />
                    <span className="text-[18px] font-bold">
                      Proposition de travaux adaptée à mon projet
                    </span>
                  </li>
                </ul>
                <Button
                  type="primary"
                  className="btn-rapport  mt-2"
                  onClick={() => handlePaymentPackage("2")}
                  disabled={_.get(dataHomeUploaded, "payment_blocked") === true}
                >
                  Obtenir mon rapport
                </Button>

                <p className="font-semibold text-[16px] mt-7 text-justify">
                  Cette offre vous permet de mesurer le niveau de fiabilité de 
                  votre DPE et de vous projeter dans des travaux permettant 
                  l'amélioration de votre logement selon votre projet (gain 
                  de lettre, budget, …).
                </p>
              </div>
              <img src={Logo} alt="logo" className="mx-auto mt-0 w-[80px]" />
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (_.get(dataHomeUploaded, "quota_use") === 1) {
    return (
      <div className="overlay">
        <div className="flex flex-col gap-4 max-w-max mx-auto">
          <div className="overlay__content">
            <div className="offre-item">
              <div className="flex-grow">
                <p className="title text-center text-[#002060ff]">Fiabilité</p>
                <p className="text-[18px] text-center mb-2">
                  <span className="text-[24px] font-semibold">
                    {_.get(dataHomeUploaded, "quota_use")} jeton
                  </span>{" "}
                  / analyse
                </p>
                <p className="text-[18px] text-center mb-1">
                  {_.get(dataHomeUploaded, "quota_info", "")}
                </p>

                <ul className="flex flex-col gap-3 my-4">
                  <li className="flex items-baseline gap-4">
                    <CheckOutlined className="text-[18px] relative top-[2px]" />
                    <span className="text-[18px] font-bold">
                      Score de fiabilité de mon DPE
                    </span>
                  </li>
                  <li className="flex items-baseline gap-4">
                    <CheckOutlined className="text-[18px] relative top-[2px]" />
                    <span className="text-[18px] font-bold">
                      Identification des anomalies éventuelles
                    </span>
                  </li>
                  <li className="flex items-baseline gap-4">
                    <CheckOutlined className="text-[18px] relative top-[2px]" />
                    <span className="text-[18px] font-bold">
                      Comparaison de mon DPE aux logements similaires
                    </span>
                  </li>
                </ul>

                <Button
                  type="primary"
                  className="btn-rapport  btn-rapport--dark"
                  onClick={handleRapport}
                >
                  Obtenir mon rapport
                </Button>

                <p className="font-semibold text-[18px] mt-4">
                  Cette offre vous permet de mesurer le niveau de fiabilité de
                  votre DPE et de comprendre les éventuels problèmes de saisies
                  ou de cohérence.
                </p>
              </div>

              <img src={Logo} alt="logo" className="mx-auto mt-5 w-[80px]" />
            </div>
          </div>
        </div>
      </div>
    );
  }

  return null;
};

export default Package;
